/**
 * Turning submitted form values into what the database stores.
 *
 * `emptyToNull` existed as four private copies — project-detail, room-detail,
 * schedule-modal and room-edit — found 2026-09-18. They were NOT identical:
 * three returned null for a boolean `false`, while schedule-modal's
 * `String(v ?? '').trim()` returned the text "false". Nothing was broken only
 * because schedule-modal is never handed a checkbox (its three call sites are
 * two dates and a notes textarea). One definition means that coincidence can't
 * quietly turn into a bug when someone adds a field.
 */

/**
 * Blank → null, text → trimmed text.
 *
 * - string: trimmed; empty or whitespace-only → null
 * - boolean: `true` → 'true', `false` → null (what the three view copies did)
 * - null / undefined → null
 * - anything else: stringified and trimmed (what schedule-modal's copy did)
 */
export function emptyToNull(v: unknown): string | null {
  if (typeof v === 'boolean') return v ? 'true' : null;
  const t = String(v ?? '').trim();
  return t === '' ? null : t;
}
